import React from 'react';
import { Field } from 'react-final-form'

function Radio(props: any) {
  
  const radioOptions = props.question.options?.split(/\r?\n/)


  const submitAnswer = (opt: string, input: any) => {
  	input.onChange(opt)

   	props.moveToNext();
  }

  return (
	<Field
          name={`${props.baseName}[answer]`}
          render={({ input, meta }) => (
  	<>
  	{radioOptions.map((opt: string, index: number) =>
  	  <div key={index} className="radio-button-option" onClick={() => submitAnswer(opt, input)}>
          {opt}
      </div>
	)}
	</>
	)}
	/>

  );
}

export default Radio;
